import { Stack, Typography } from '@mui/material';
import theme from '../../theme';
import { ChatBubbleOutline } from '@mui/icons-material';

const CommentCount = ({ commentCount, variant = 'card' }) => {
  const iconSizes = {
    card: { xs: 12, md: 13, lg: 16 },
    detail: 16,
    reviewDetail: 20,
  };

  const typoFontSizes = {
    card: { xs: 12, md: 13, lg: 14 },
    detail: 14,
    reviewDetail: 14,
  };

  const iconSize = iconSizes[variant];
  const typoFontSize = typoFontSizes[variant];

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <ChatBubbleOutline sx={{ fontSize: iconSize, color: '#777777 !important' }} />
      <Typography
        sx={{ fontSize: typoFontSize, color: theme.palette.black[4], whiteSpace: 'nowrap' }}
      >
        {commentCount}
      </Typography>
    </Stack>
  );
};

export default CommentCount;
